import { cn } from "@/lib/utils";
import type { JustificationItem } from "@/types/hld-wizard";

interface JustificationPillsProps {
  items: JustificationItem[];
  selected: string[];
  onToggle: (id: string) => void;
  max: number;
  disabled?: boolean;
}

export function JustificationPills({
  items,
  selected,
  onToggle,
  max,
  disabled,
}: JustificationPillsProps) {
  const atMax = selected.length >= max;

  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item) => {
        const isSelected = selected.includes(item.id);
        const isDisabled = disabled || (atMax && !isSelected);

        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onToggle(item.id)}
            disabled={isDisabled}
            className={cn(
              "rounded-full border px-4 py-2 text-sm transition-all",
              isSelected
                ? "border-primary bg-primary/10 text-primary font-medium"
                : "border-border bg-card text-muted-foreground hover:border-primary/40 hover:text-foreground",
              isDisabled && !isSelected && "cursor-not-allowed opacity-40",
            )}
          >
            {item.text}
          </button>
        );
      })}
      {max > 1 && (
        <span className="self-center text-xs text-muted-foreground">
          {selected.length}/{max}
        </span>
      )}
    </div>
  );
}
